// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__JqvMR","options":"AnswerScale_options__3PKNE","selected":"AnswerScale_selected__2yQky"};